import request from "./request";

const Insumo = {
  consultar: criterio =>
    request.get("/composicao/subgrupos", {
      params: {
        nome: criterio.nome,
        grupo: criterio.grupo,
        page: criterio.pagina,
        limit: criterio.limite
      }
    }),
  cadastrar: subgrupo => request.post("/composicao/subgrupos", subgrupo),
  alterar: subgrupo => request.put(`/composicao/subgrupos/${subgrupo.ID}`, subgrupo),
  excluir: ids =>
    request.del("/composicao/subgrupos", {
      params: {
        id: [].concat(ids).join(",")
      }
    }),
  buscar: id => request.get(`/composicao/subgrupos/${id}`)
};

export default Insumo;



// WEBPACK FOOTER //
// ./src/services/insumo.js